<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To Dick Hover, who got me hooked on reading and storytelling.</p><br/>
<p style="text-align: center;"><em>Civis illustris</em>, pal</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2af58492